<div class="row" id="globalClassroom">
  <div class="leftsideAllMovies order-2 order-lg-1 pr-lg-0 bg-white"
    [ngClass]="{'col-lg-6 col-12 ':checkExpandClick,'col-lg-4 col-12 ':!checkExpandClick}" id="allMoviesLeft">
    <div #tabSelected class="tab-selector-box">
      <div *ngIf="isExpedition" class="d-flex justify-content-between align-items-center">
        <div class="mulish-normal text-block mr-2">
          {{"Watch videos and discover what's going on the other side of the globe." | translate}}
        </div>
        <div (click)="selectTab(0)" class="py-2 px-3 d-flex badge-custom align-items-center cursor-pointer mulish-bold">
          <span> {{'Watch videos' | translate | uppercase}} </span>
          <mat-icon class="ml-3">arrow_right_alt</mat-icon>
        </div>
      </div>

      <div *ngIf="!isExpedition" class="d-flex justify-content-between align-items-center">
        <div class="mulish-normal text-block mr-2">
          {{"Learn about Sustainable development goals by participating in the quiz." | translate}}
        </div>
        <div (click)="selectTab(1)" class="py-2 px-3 d-flex badge-custom align-items-center cursor-pointer mulish-bold">
          <span> {{'Expedition' | translate | uppercase}} </span>
          <mat-icon class="ml-3">arrow_right_alt</mat-icon>
        </div>
      </div>
    </div>
    <div *ngIf="!isExpedition">
      <div class="bg-white">
        <div *ngIf="blnLoader" class="">
          <app-loader class="loader-block" [parentData]="true"></app-loader>
        </div>

        <div class="text-center pt-5 w-75 margin-auto">
          <img src="assets/images/expand-icon.svg" alt=""
            class="position-absolute right-align pr-4 pointer-cursor d-none d-lg-block" (click)="expandClick()">
          <p class="mulish-normal ">
            {{"Our Global classrooms" | translate}}
          </p>
          <p class="amatic-bold text-xxl">
            {{"Discover what's going on on the other side of the globe" | translate}}
          </p>
        </div>

        <div class="d-flex justify-content-between px-4 pt-4 mulish-normal text-xs">
          <div class="w-30">
            <p class="mb-2">
              {{'Country' | translate}}
            </p>
            <select class="custom-select" [(ngModel)]="selectedCountryId" (change)="countryChange(selectedCountryId)">
              <option *ngFor="let countries of lstCountries" [value]="countries.id">{{countries['name'] | translate}}
              </option>
            </select>
          </div>
          <div class="w-30">
            <p class="mb-2">
              SDG
            </p>
            <select class="custom-select" [(ngModel)]="selectedSdgId" (ngModelChange)="sdgChange(selectedSdgId)">
              <option selected *ngFor="let goal of allSdg" [value]="goal.id">
                {{goal['name'] | translate}}
              </option>

            </select>
          </div>
          <div class="w-30">
            <p class="mb-2">
              {{'Subject' | translate}}
            </p>
            <select #selectSubject id="selectSubject" class="custom-select " [(ngModel)]="selectedSubjectId"
              (change)="subjectChange(selectedSubjectId)">
              <option *ngFor="let subject of allSubject ;let i =index;" class="selectSubject" [value]="subject.id">
                {{subject['name'] | translate}}</option>

            </select>
          </div>
        </div>

        <div class="d-flex justify-content-between mx-4 my-3 mulish-normal border-btm">
          <div class="">
            <p class="mulish-bold text-xxs">
              <a class="text-danger pointer-cursor" (click)="clearFilter()">
                {{"CLEAR FILTER" | translate}}
              </a>
            </p>
          </div>
          <div class="" *ngIf="AllMovies?.length>0">
            <p class="mulish-normal text-xs">{{AllMovies?.length}} {{'Movies' | translate}}</p>
          </div>

        </div>

        <div class="px-4">
          <div class="row all-movies pb-4" id="allmovies" #divToScrollMovie>

            <div class="w-100 col-sm-6 col-12 my-lg-4" [ngClass]="{'col-lg-4 col-12':checkExpandClick,'mt-4':i>0}"
              *ngFor="let movies of AllMovies;let i=index;">
              <div class="d-flex flex-column justify-content-center" style="height: 67.6px;">
                <p class="mulish-bold text-xs line-height-120">
                  {{movies.description}}
                </p>
                <p class="mulish-normal text-xs d-flex align-items-center mb-md-0 mb-2 line-height-120">
                  <span class="pr-2 d-flex align-items-center"><img [src]="movies.country.flag" alt=""
                      class="movielist-countryflag"></span>
                  {{movies.country.name}}
                </p>
              </div>

              <div class="position-relative pointer-cursor" (click)="movieClick(movies,'')">
                <div class="d-flex align-items-center justify-content-center w-100 h-100 position-absolute"
                  style="z-index: 1;">
                  <img src="assets/images/play-icon.svg" alt="" class="play-icon ">
                </div>
                <div class="m-modal-video__container--cinemascope">
                  <img [src]="movies.movieThumbnail" alt="" class="pointer-cursor left-side-image-border ">
                </div>
              </div>
            </div>

            <div class="w-100 col-12 pr-lg-3 mt-4 text-center" *ngIf="AllMovies?.length==0">
              <img src="assets/images/no-data-all-video.svg" alt="">
              <div class="mt-3">
                <p class="text-center mulish-normal text-xs">
                  {{"No videos available for selected criteria, Kindly try changing parameters" | translate}}</p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div *ngIf="isExpedition">
      <div class=" ">
        <div class="px-4 pb-4 bg-white">
          <div class="text-center mt-4 margin-auto" *ngIf="!isLoggedIn">
            <p class="amatic-bold text-xxl">
              {{"Welcome to global expedition" | translate}}
            </p>
            <p class="mulish-normal text-14">
              {{"Learn about Sustainable development goals by participating in the quiz" | translate}}
            </p>
          </div>

          <div (click)="introModalOpen(true)"
            class="py-2 d-flex text-danger align-items-center cursor-pointer mulish-bold">
            <span class="text-decoration-underline"> {{'View introductary videos' | translate | uppercase}} </span>
            <mat-icon class="ml-1">arrow_right_alt</mat-icon>
          </div>

          <div class="d-flex justify-content-between pt-4 mulish-normal text-xs">
            <div class="w-45">
              <p class="mb-2">
                {{'Country' | translate}}
              </p>
              <select class="custom-select" data-toggle="tooltip" title="{{selectedCountryExpedition}}"
                [(ngModel)]="selectedCountryIdExpedition"
                (change)="countryChangeExpedition(selectedCountryIdExpedition)">
                <option *ngFor="let countries of lstCountriesExpedition" [value]="countries.id">
                  {{countries['name'] | translate}}
                </option>
              </select>
            </div>
            <div class="w-45">
              <p class="mb-2">
                SDG
              </p>
              <select class="custom-select" data-toggle="tooltip" title="{{selectedSdgExpedition}}"
                [(ngModel)]="selectedSdgIdExpedition" (ngModelChange)="sdgChangeExpedition(selectedSdgIdExpedition)">
                <option selected *ngFor="let goal of allSdgExpedition" [value]="goal.id">
                  {{goal['name'] | translate}}
                </option>

              </select>
            </div>
            <!-- <div class="w-30">
              <p class="mb-2">
                {{'Subject' | translate}}
              </p>
              <select #selectSubject id="selectSubject" class="custom-select " data-toggle="tooltip"
                title="{{selectedSubjectExpedition}}" [(ngModel)]="selectedSubjectIdExpedition"
                (change)="subjectChangeExpedition(selectedSubjectIdExpedition)">
                <option *ngFor="let subject of allSubjectExpedition ;let i =index;" class="selectSubject"
                  [value]="subject.id">
                  {{subject['name'] | translate}}</option>

              </select>
            </div> -->
          </div>
        </div>

        <div #expeditionTab [ngClass]="[isLoggedIn ? 'expedition-all-movies' : 'expedition-no-movies']"
          class="p-4 bg-custom-lite " id="expedition-tab" infiniteScroll [infiniteScrollDistance]="2"
          [infiniteScrollThrottle]="50" (scrolled)="onQuestionScroll()" [scrollWindow]="false">
          <div class="bg-white p-4 rounded-5">

            <!-- <div class="d-flex justify-content-around my-4">
              <div class="d-flex flex-column justify-content-around align-items-center">
                <img class="country-img" *ngIf="selectedCountryImageExpedition != null"  [src]="selectedCountryImageExpedition" alt="">
                <img class="country-img" *ngIf="selectedCountryImageExpedition == null"  src="./assets/images/world.svg" alt="">
                <div class="mx-3 mt-2 text-xs">
                  {{selectedCountryExpedition}}
                </div>
              </div>
              <div class="d-flex flex-column justify-content-around align-items-center">
                <img *ngIf="selectedSdgImageExpedition != null" height="40" [src]="selectedSdgImageExpedition" alt="">
                <img *ngIf="selectedSdgImageExpedition == null" height="40" src="./assets/images/target.svg" alt="">
                <div class="mx-3 mt-2 text-xs">
                  {{selectedSdgExpedition}}
                </div>
              </div>
              <div class="d-flex flex-column justify-content-around align-items-center">
                <img height="40" src="./assets/images/book.svg" alt="">
                <div class="mx-3 mt-2 text-xs">
                  {{selectedSubjectExpedition}}
                </div>
              </div>
            </div> -->

            <div class="text-center mt-4 margin-auto" *ngIf="isLoggedIn">
              <p class="amatic-bold text-xxl px-lg-5 mx-lg-5 line-ht-normal"
                *ngIf="questionStatus?.badge == 'None' || questionStatus?.badge == 'Bronze'">
                {{"You’re just starting out! Keep it up!!" | translate}}
              </p>
              <p class="amatic-bold text-xxl line-ht-normal"
                *ngIf="questionStatus?.badge == 'Silver' || questionStatus?.badge == 'Gold'">
                {{"Wow! You have more knowledge about this country more than 80% people" | translate: {percentage : questionStatus?.badge == 'Silver'? 60:80} }}
              </p>
            </div>

            <!-- <div>
              <p class="mulish-bold text-center">
                {{'Questions in this topic' | translate}}
              </p>
              <div class="d-flex justify-content-center align-items-center mt-3 mb-4 pb-3">
                <div class="all-qstn-count text-xxs mr-2 pointer-cursor" (click)="difficultyChangeExpedition('')">
                  {{'All' | translate}}: {{questionStatus?.total_questions}}</div>
                <div class="easy-qstn-count text-xxs mr-2 pointer-cursor" (click)="difficultyChangeExpedition(1)">
                  {{'Easy' | translate}}: {{questionStatus?.difficulty_count?.easy}}</div>
                <div class="medium-qstn-count text-xxs mx-2 pointer-cursor" (click)="difficultyChangeExpedition(2)">
                  {{'Medium' | translate}}: {{questionStatus?.difficulty_count?.medium}}
                </div>
                <div class="hard-qstn-count text-xxs ml-2 pointer-cursor" (click)="difficultyChangeExpedition(3)">
                  {{'Hard' | translate}}: {{questionStatus?.difficulty_count?.hard}}</div>
              </div>
            </div> -->

            <div class="d-flex justify-content-center align-items-center">
              <div class="text-center" *ngIf="questionStatus?.badge == 'None'">
                <img class="m-2 question-badge" src="assets/images/no-badge.svg" alt="">
                <div>{{'No badge yet' | translate}}</div>
              </div>
              <div class="text-center" *ngIf="questionStatus?.badge == 'Gold'">
                <img class="m-2 question-badge" src="assets/images/gold-badge.svg" alt="">
                <div>{{'Gold' | translate}}</div>
              </div>
              <div class="text-center" *ngIf="questionStatus?.badge == 'Silver'">
                <img class="m-2 question-badge" src="assets/images/silver-badge.svg" alt="">
                <div>{{'Silver' | translate}}</div>
              </div>
              <div class="text-center" *ngIf="questionStatus?.badge == 'Bronze'">
                <img class="m-2 question-badge" src="assets/images/bronze-badge.svg" alt="">
                <div>{{'Bronze' | translate}}</div>
              </div>
              <div class="text-center" class="ml-4 d-flex flex-column justify-content-between">
                <div>
                  <div class="text-xs mb-2 text-default">
                    {{'Your score' | translate}}:
                  </div>
                  <div class="score-chip mb-3">
                    {{'Score :' | translate}} {{questionStatus?.score}} /
                    {{questionStatus?.maximum_score}}
                  </div>
                </div>
                <div class="">
                  <div class="text-xs mb-2 text-default">
                    {{'Questions completed :' | translate}} {{questionStatus?.answered_questions}} /
                    {{questionStatus?.total_questions}}
                  </div>
                  <div class="custom-progress">
                    <div class="progress">
                      <div class="progress-bar bg-primary" role="progressbar"
                        [style.width.%]="questionStatus?.attempted_percentage" aria-valuenow="12" aria-valuemin="0"
                        aria-valuemax="100"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex flex-column align-items-center my-5" *ngIf="isLoggedIn">
              <!-- <p>
                {{'Start playing the quiz and earn badges!' | translate}}
              </p> -->

              <div>
                <p class="text-xs text-center text-default mx-3">
                  {{'You have count questions to go, Choose your difficulty and click on Start playing to play the game' | translate :{count: questionStatus?.total_questions} }}
                </p>
                <div class="d-flex justify-content-center align-items-center flex-wrap my-4">
                  <div class="difficulty-filter text-xxs mr-2 mb-2 pointer-cursor"
                    [ngClass]="{'difficulty-selected-filter': selectedDifficultyIdExpedition==''}"
                    (click)="difficultyChangeExpedition('')">
                    {{'All' | translate}}: {{questionStatus?.difficulty_count?.all}}</div>
                  <div class="difficulty-filter text-xxs mr-2 mb-2 pointer-cursor"
                    [ngClass]="{'difficulty-selected-filter': selectedDifficultyIdExpedition==1}"
                    (click)="difficultyChangeExpedition(1)">
                    {{'Easy' | translate}}: {{questionStatus?.difficulty_count?.easy}}</div>
                  <div class="difficulty-filter text-xxs mx-2 mb-2 pointer-cursor"
                    [ngClass]="{'difficulty-selected-filter': selectedDifficultyIdExpedition==2}"
                    (click)="difficultyChangeExpedition(2)">
                    {{'Medium' | translate}}: {{questionStatus?.difficulty_count?.medium}}
                  </div>
                  <div class="difficulty-filter text-xxs ml-2 mb-2 pointer-cursor"
                    [ngClass]="{'difficulty-selected-filter': selectedDifficultyIdExpedition==3}"
                    (click)="difficultyChangeExpedition(3)">
                    {{'Hard' | translate}}: {{questionStatus?.difficulty_count?.hard}}</div>
                </div>
              </div>

              <div *ngIf="lstUnattendedQuestions.length == 0 && questionStatus?.answered_questions != 0"
                class="completion-info">
                <mat-icon class="mr-2">done</mat-icon>
                <span *ngIf="selectedDifficultyIdExpedition == ''">
                  {{'You have completed all questions!' | translate}}
                </span>
                <span *ngIf="selectedDifficultyIdExpedition == 3">
                  {{'You have completed all hard questions!' | translate}}
                </span>
                <span *ngIf="selectedDifficultyIdExpedition == 2">
                  {{'You have completed all medium questions!' | translate}}
                </span>
                <span *ngIf="selectedDifficultyIdExpedition == 1">
                  {{'You have completed all easy questions!' | translate}}
                </span>
              </div>

              <div *ngIf="lstUnattendedQuestions.length != 0"
                class="bg-danger py-2 px-3 d-flex text-white badge-custom align-items-center cursor-pointer mulish-bold"
                (click)="startPlaying()">
                <span *ngIf="questionStatus?.answered_questions == 0"> {{'Start playing' | translate | uppercase}}
                </span>
                <span *ngIf="questionStatus?.answered_questions != 0"> {{'Continue playing' | translate | uppercase}}
                </span>
                <mat-icon class="ml-3">arrow_right_alt</mat-icon>
              </div>
            </div>
            <div class="d-flex flex-column align-items-center my-5" *ngIf="!isLoggedIn">
              <!-- <p>
                {{'Start playing the quiz and earn badges!' | translate}}
              </p> -->

              <div>
                <p class="text-xs text-center text-default mx-3">
                  {{'You have count questions to go, Choose your difficulty and click on Start playing to play the game' | translate :{count: questionStatus?.total_questions} }}
                </p>
                <div class="d-flex justify-content-center align-items-center flex-wrap my-4">
                  <div class="difficulty-filter text-xxs mr-2 mb-2 pointer-cursor"
                    [ngClass]="{'difficulty-selected-filter': selectedDifficultyIdExpedition==''}"
                    (click)="difficultyChangeExpedition('')">
                    {{'All' | translate}}: {{questionStatus?.difficulty_count?.all}}</div>
                  <div class="difficulty-filter text-xxs mr-2 mb-2 pointer-cursor"
                    [ngClass]="{'difficulty-selected-filter': selectedDifficultyIdExpedition==1}"
                    (click)="difficultyChangeExpedition(1)">
                    {{'Easy' | translate}}: {{questionStatus?.difficulty_count?.easy}}</div>
                  <div class="difficulty-filter text-xxs mx-2 mb-2 pointer-cursor"
                    [ngClass]="{'difficulty-selected-filter': selectedDifficultyIdExpedition==2}"
                    (click)="difficultyChangeExpedition(2)">
                    {{'Medium' | translate}}: {{questionStatus?.difficulty_count?.medium}}
                  </div>
                  <div class="difficulty-filter text-xxs ml-2 mb-2 pointer-cursor"
                    [ngClass]="{'difficulty-selected-filter': selectedDifficultyIdExpedition==3}"
                    (click)="difficultyChangeExpedition(3)">
                    {{'Hard' | translate}}: {{questionStatus?.difficulty_count?.hard}}</div>
                </div>
              </div>

              <div
                class="bg-danger py-2 px-3 d-flex text-white badge-custom align-items-center cursor-pointer mulish-bold"
                (click)="startPlaying()">
                <span *ngIf="questionStatus?.answered_questions == 0"> {{'Start playing' | translate | uppercase}}
                </span>
                <span *ngIf="questionStatus?.answered_questions != 0"> {{'Continue playing' | translate | uppercase}}
                </span>
                <mat-icon class="ml-3">arrow_right_alt</mat-icon>
              </div>
            </div>
          </div>

          <div class="bg-white">
            <!-- <p class="mulish-bold text-center">
              {{'Questions in this topic' | translate}}
            </p> -->

            <mat-tab-group [(selectedIndex)]="questionTabIndex">
              <mat-tab label="{{'Unattended' | translate}}({{Unattended}})">
                <div class="p-4 bg-white">
                  <div class="q-preview my-3" *ngFor="let item of lstUnattendedQuestions;let i =index;">
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="d-flex align-items-center">
                        <div class="mulish-bold mr-3">
                          <!-- QN #{{i+1}} -->
                          QN #{{item.question_number}}
                        </div>
                        <p class="text-xxs mulish-bold mb-0 difficult-level-easy d-flex align-items-center justify-content-center px-3"
                          *ngIf="item.difficulty == 1">{{'Easy' | translate}}</p>
                        <p class="text-xxs mulish-bold mb-0 difficult-level-medium d-flex align-items-center justify-content-center px-3"
                          *ngIf="item.difficulty == 2">{{'Medium' | translate}}</p>
                        <p class="text-xxs mulish-bold mb-0 difficult-level-hard d-flex align-items-center justify-content-center px-3"
                          *ngIf="item.difficulty == 3">{{'Hard' | translate}}</p>
                      </div>

                      <div class="score-chip">
                        {{'Score :' | translate}} {{item.score || 0}} / {{item.total_score}}
                      </div>
                    </div>
                    <div class="d-flex justify-content-between align-items-center mt-4">
                      <div class="mulish-normal text-block mr-2">
                        {{item.title}}
                      </div>
                      <div (click)="viewSingleQuestion(item.id,false)"
                        class="py-2 px-3 d-flex badge-custom align-items-center cursor-pointer mulish-bold">
                        <span> {{'Play quiz' | translate | uppercase}} </span>
                        <mat-icon class="ml-3">arrow_right_alt</mat-icon>
                      </div>
                    </div>
                  </div>
                  <div class="my-3 text-center" *ngIf="lstUnattendedQuestions.length == 0">
                    <img class="m-5" src="./assets/images/unattended_no_items.svg" alt="">
                    <p class="text-xxs mulish-normal text-default">
                      {{'You don’t have any unattended questions left for this topic! Try changing the topics to attend more questions' | translate}}
                    </p>
                  </div>
                </div>
              </mat-tab>
              <mat-tab label="{{'Right' | translate}}({{rightQuestionLabel}})">
                <div class="p-4 bg-white">
                  <div class="q-preview my-3" *ngFor="let item of lstRightQuestions;let i =index;">
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="d-flex align-items-center">
                        <div class="mulish-bold mr-3">
                          <!-- QN #{{i+1}} -->
                          QN #{{item.question_number}}
                        </div>
                        <p class="text-xxs mulish-bold mb-0 difficult-level-easy d-flex align-items-center justify-content-center px-3"
                          *ngIf="item.difficulty == 1">{{'Easy' | translate}}</p>
                        <p class="text-xxs mulish-bold mb-0 difficult-level-medium d-flex align-items-center justify-content-center px-3"
                          *ngIf="item.difficulty == 2">{{'Medium' | translate}}</p>
                        <p class="text-xxs mulish-bold mb-0 difficult-level-hard d-flex align-items-center justify-content-center px-3"
                          *ngIf="item.difficulty == 3">{{'Hard' | translate}}</p>
                      </div>

                      <div class="score-chip">
                        {{'Score :' | translate}} {{item.score || 0}} / {{item.total_score}}
                      </div>
                    </div>
                    <div class="d-flex justify-content-between align-items-center mt-4">
                      <div class="mulish-normal text-block mr-2">
                        {{item.title}}
                      </div>
                      <div (click)="viewSingleQuestion(item.id,true)"
                        class="py-2 px-3 d-flex badge-custom align-items-center cursor-pointer mulish-bold">
                        <span> {{'View' | translate | uppercase}} </span>
                        <mat-icon class="ml-3">arrow_right_alt</mat-icon>
                      </div>
                    </div>
                  </div>
                  <div class="my-3 text-center" *ngIf="lstRightQuestions.length == 0">
                    <img class="m-5" src="./assets/images/attended_no_items.svg" alt="">
                    <p class="text-xxs mulish-normal text-default">
                      {{'You don’t have any questions for the selected criteria!' | translate}}
                    </p>
                  </div>
                </div>
              </mat-tab>
              <mat-tab label="{{'Wrong' | translate}}({{wrongQuestionLabel}})">
                <div class="p-4 bg-white">
                  <div class="q-preview my-3" *ngFor="let item of lstWrongQuestions;let i =index;">
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="d-flex align-items-center">
                        <div class="mulish-bold mr-3">
                          <!-- QN #{{i+1}} -->
                          QN #{{item.question_number}}
                        </div>
                        <p class="text-xxs mulish-bold mb-0 difficult-level-easy d-flex align-items-center justify-content-center px-3"
                          *ngIf="item.difficulty == 1">{{'Easy' | translate}}</p>
                        <p class="text-xxs mulish-bold mb-0 difficult-level-medium d-flex align-items-center justify-content-center px-3"
                          *ngIf="item.difficulty == 2">{{'Medium' | translate}}</p>
                        <p class="text-xxs mulish-bold mb-0 difficult-level-hard d-flex align-items-center justify-content-center px-3"
                          *ngIf="item.difficulty == 3">{{'Hard' | translate}}</p>
                      </div>

                      <div class="score-chip">
                        {{'Score :' | translate}} {{item.score || 0}} / {{item.total_score}}
                      </div>
                    </div>
                    <div class="d-flex justify-content-between align-items-center mt-4">
                      <div class="mulish-normal text-block mr-2">
                        {{item.title}}
                      </div>
                      <div (click)="viewSingleQuestion(item.id,true)"
                        class="py-2 px-3 d-flex badge-custom align-items-center cursor-pointer mulish-bold">
                        <span> {{'View' | translate | uppercase}} </span>
                        <mat-icon class="ml-3">arrow_right_alt</mat-icon>
                      </div>
                    </div>
                  </div>
                  <div class="my-3 text-center" *ngIf="lstWrongQuestions.length == 0">
                    <img class="m-5" src="./assets/images/attended_no_items.svg" alt="">
                    <p class="text-xxs mulish-normal text-default">
                      {{'You don’t have any questions for the selected criteria!' | translate}}
                    </p>
                  </div>
                </div>
              </mat-tab>
            </mat-tab-group>

            <div class="infinity-loader" *ngIf="infinityLoader">
              <img src="assets/images/loader.gif" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>




  <!-- MAP sections -->
  <div class="order-1 order-lg-2 pl-lg-0 position-relative"
    [ngClass]="{'col-lg-6 col-12 ':checkExpandClick,'col-lg-8 col-12':!checkExpandClick}">

    <div #MapVideoDiv class="video-map" *ngIf="!isExpedition">

      <!-- map banner not loggedin-->
      <div #MapHeader class="row map-banner-not-log position-absolute mx-0" *ngIf="!isLoggedIn">
        <div class="col-12 px-0">
          <p class="mulish-bold text-14"> {{'Hello user!' | translate}}</p>
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <div class="px-0">
            <p class="mulish-normal text-14 color-5F5F5F">
              {{'Sign up your account using referral code or login to your existing account to start playing the quiz' | translate}}
            </p>
            <!-- <p class="mulish-bold text-13 font-red"> {{'How do I get a referral?' | translate}}</p> -->
          </div>
          <div class="px-0 ml-3">
            <div class="d-flex justify-content-between wd-max-content">

              <div
                class="bg-danger py-2 px-3 d-flex text-13 text-white badge-custom align-items-center cursor-pointer mulish-bold"
                (click)="signup()">
                <span> {{'Sign up using referral' | translate | uppercase}} </span>
                <mat-icon class="ml-3">arrow_right_alt</mat-icon>
              </div>

              <div class=" ml-3 py-2 px-3 d-flex login-button align-items-center cursor-pointer mulish-bold"
                (click)="login()">
                <span> {{'Login' | translate | uppercase}} </span>
              </div>

            </div>


          </div>
        </div>
      </div>
      <!-- map banner not loggedin-->

      <!-- map banner  loggedin-->
      <div #MapHeader class="map-video-header position-absolute" *ngIf="isLoggedIn">

        <div class="d-flex">
          <div class="mr-5">
            <p class="mulish-bold text-14 mb-0">{{userData?.name}}</p>
          </div>
          <div class="d-flex align-items-center">
            <p class="mulish-bold mb-0 text-xxs color-5F5F5F pointer-cursor" (click)="signOut()">
              {{'Sign out' | translate | uppercase}}</p>
          </div>
        </div>

      </div>
      <!-- map banner loggedin -->

      <agm-map #AgmMap class="video-map-height" [ngClass]="{'logout-map-ht': !isLoggedIn}" [latitude]="lat"
        [longitude]="lng" [zoom]="zoom" [styles]=style [minZoom]="2" [maxZoom]="4" [fitBounds]="true"
        [streetViewControl]="false" (mapReady)="videoMapReady($event)">

        <agm-marker *ngFor="let country of countywiseData; let i = index" (markerClick)="markerCliked(country)"
          (mouseOver)="clickedMarker(country, country,iw)" [latitude]="country.latitude" [longitude]="country.longitude"
          [label]="{color: 'white', text: country.country_videos.length.toString()}"
          [iconUrl]="country.marker || 'assets/images/india-marker.svg'" [agmFitBounds]="true">

          <agm-info-window #iw [isOpen]="isInfoWindowOpen(country.id)" (showCloseButton)="false">
            <div class="row mx-0 info-width">
              <div class="position-absolute info-close-button pointer-cursor "><img src="assets/images/close-movie.svg"
                  alt="" class="info-window-close" (click)="closeInfoWindow(countywiseData)"></div>
              <div class="col-12 px-0 border-btm d-flex flex-row pb-4">
                <div class="d-flex align-items-center pr-4">
                  <img height="30" [src]="country.flag" alt="">
                </div>

                <p class="amatic-bold text-xxl mb-0">{{country.name}}</p>

              </div>
              <div class="col-12 px-0 mt-3">
                <p *ngIf="country.country_videos.length != 0 ">
                  {{country.country_videos[0].current_slide+1}} of {{country.country_videos.length}} Videos
                </p>
                <p *ngIf="country.country_videos.length == 0 "> 0 Videos</p>
              </div>
              <div class="mulish-bold text-sm col-12 px-0 heading-slider" *ngIf="country.country_videos.length != 0 ">
                <p class="mb-0 info-heading text-break">
                  <!-- {{countywiseData[country.name][countywiseData[country.name][0].current_slide].heading}} -->
                  {{country.country_videos[country.country_videos[0].current_slide].description}}
                </p>
              </div>
              <div class="col-12 px-0 mt-3" *ngIf="country.country_videos.length != 0 ">
                <div id="maincarousel">
                  <mat-carousel [hideArrows]="false" [hideIndicators]="true" [autoplay]="false"
                    (change)="updateSlider($event,country.country_videos)" [slideHeight]="'100%'" class="movieslider">

                    <mat-carousel-slide #matCarouselSlide *ngFor="let slide of country.country_videos; let i = index"
                      [image]="slide.movieThumbnail" class="carousel-movie">
                      <div class="slider-content" (click)="movieClick(slide,iw)">

                        <img src="assets/images/play-icon.svg" alt="" class="play-icon">

                      </div>
                    </mat-carousel-slide>
                  </mat-carousel>

                </div>

              </div>
              <div class="col-12 px-0 mt-3" *ngIf="country.country_videos.length == 0 ">
                <div>
                  <img src="assets/images/no-data-info.svg" alt="" class="w-100">
                </div>
                <p class="mulish-normal text-xxs text-center">
                  {{"Selected country doesn’t have any videos uploaded" | translate}}</p>

              </div>
              <div class="col-12 px-0" *ngIf="country.country_videos.length != 0 ">
                <p class="mulish-bold text-xxs mt-4">
                  <a class="text-danger pointer-cursor" (click)="showAllVideos(country,iw)">
                    {{"SEE ALL VIDEOS" | translate}}
                  </a>
                </p>
              </div>

            </div>
          </agm-info-window>

        </agm-marker>

      </agm-map>
    </div>

    <div #MapDiv class="expidetion-map" *ngIf="isExpedition">
      <!-- map banner not loggedin-->
      <div #MapHeader class="row map-banner-not-log position-absolute mx-0" *ngIf="!isLoggedIn">
        <div class="col-12 px-0">
          <p class="mulish-bold text-14"> {{'Hello user!' | translate}}</p>
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <div class="px-0">
            <p class="mulish-normal text-14 color-5F5F5F">
              {{'Sign up your account using referral code or login to your existing account to start playing the quiz' | translate}}
            </p>
            <!-- <p class="mulish-bold text-13 font-red"> {{'How do I get a referral?' | translate}}</p> -->
          </div>
          <div class="px-0 ml-3">
            <div class="d-flex justify-content-between wd-max-content">

              <div
                class="bg-danger py-2 px-3 d-flex text-13 text-white badge-custom align-items-center cursor-pointer mulish-bold"
                (click)="signup()">
                <span> {{'Sign up using referral' | translate | uppercase}} </span>
                <mat-icon class="ml-3">arrow_right_alt</mat-icon>
              </div>

              <div class=" ml-3 py-2 px-3 d-flex login-button align-items-center cursor-pointer mulish-bold"
                (click)="login()">
                <span> {{'Login' | translate | uppercase}} </span>
              </div>

            </div>


          </div>
        </div>
      </div>
      <!-- map banner not loggedin-->

      <!-- map banner  loggedin-->
      <div #MapHeader class="row map-header position-absolute" *ngIf="isLoggedIn">
        <div class="col-12 px-0">
          <div class="d-flex justify-content-between">
            <div>
              <p class="mulish-bold text-14 mb-0">{{participantData?.name}}</p>
            </div>

            <div class="d-flex">
              <div class="score-chip d-flex align-items-center">
                <img class="user-badge" *ngIf="participantData?.info.badge == 'None'" src="assets/images/no-badge.svg"
                  alt="">
                <img class="user-badge" *ngIf="participantData?.info.badge == 'Bronze'"
                  src="assets/images/bronze-badge.svg" alt="">
                <img class="user-badge" *ngIf="participantData?.info.badge == 'Silver'"
                  src="assets/images/silver-badge.svg" alt="">
                <img class="user-badge" *ngIf="participantData?.info.badge == 'Gold'" src="assets/images/gold-badge.svg"
                  alt="">
                <p *ngIf="participantData?.info.badge == 'None'" class="mb-0 pl-2 text-xxs">
                  {{'No badge yet' | translate}}</p>
                <p *ngIf="participantData?.info.badge != 'None'" class="mb-0 pl-2 text-xxs">
                  {{participantData?.info.badge | translate}}</p>
              </div>
              <div class="score-chip mx-3 d-flex align-items-center">
                {{'Score :' | translate}} {{participantData?.info.score}} / {{participantData?.info.maximum_score}}
              </div>
              <div class="d-flex align-items-center">
                <p class="mulish-bold mb-0 text-xxs color-5F5F5F pointer-cursor" (click)="signOut()">
                  {{'Sign out' | translate | uppercase}}</p>
              </div>
            </div>

          </div>

        </div>
        <div class="col-12 px-0 mt-3">
          <div class="">
            <div class="d-flex align-items-center filter-progress">
              <div>
                <p class="mulish-normal text-14 mb-0">{{'SDG completed:' | translate}}
                  {{participantData?.info.completed_sdg_count}}
                  / {{participantData?.info.total_sdg_count}}</p>
              </div>
              <div class="d-flex align-items-center sdgBanner-wd">
                <div class="custom-progress ml-3 w-100">
                  <div class="progress">
                    <div class="progress-bar bg-primary" role="progressbar"
                      [style.width.%]="participantData?.info.sdg_completion_percentage" aria-valuenow="12"
                      aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                </div>

              </div>
              <div (click)="openSdg()" class="sdg-badge-info">
                <!-- <img (click)="openSdg()" class="info-icon" src="../../../assets/images/sdg_info.svg" alt=""> -->
                <img height="16" src="assets/images/redTrophy.svg" alt="">
                <span class="ml-2">
                  {{'View sdg badges' | translate | uppercase}}
                </span>
              </div>
            </div>

            <!-- <div>
              <p class="mulish-normal text-xxs">Showing 01 to 08 of 17</p>
            </div> -->

          </div>

        </div>
        <div class="col-12 px-0 mt-3 position-relative">
          <div class="scrolling-wrapper row flex-row flex-nowrap mx-0" #mapbanner>
            <div class="position-absolute right-align leave-card-icon d-md-flex align-items-center d-none h-100">
              <img src="assets/images/right-arrow.svg" alt="" (click)="nextClick()" class="pointer-cursor">
            </div>
            <div
              class="position-absolute left-align pull-left leave-card-icon d-md-flex align-items-center d-none h-100">
              <img src="assets/images/left-arrow.svg" alt="" (click)="previousClick()" class="pointer-cursor">
            </div>
            <div class="map-banner-card pointer-cursor" id="{{item.id}}"
              *ngFor="let item of lstAllSDGBanner;let i =index;">
              <div class="d-flex align-items-center w-100" (click)="bannerClicked(item,i,$event)" data-toggle="tooltip"
                title="{{item.name}}">
                <div class="position-relative">
                  <img *ngIf="item.info.badge == 'Gold'" src="assets/images/gold-badge.svg" alt="" width="13"
                    height="13" class="position-absolute" style="right: -10%;top: -5%;">
                  <img *ngIf="item.info.badge == 'Silver'" src="assets/images/silver-badge.svg" alt="" width="13"
                    height="13" class="position-absolute" style="right: -10%;top: -5%;">
                  <img *ngIf="item.info.badge == 'Bronze'" src="assets/images/bronze-badge.svg" alt="" width="13"
                    height="13" class="position-absolute" style="right: -10%;top: -5%;">
                  <img *ngIf="item.info.badge == 'None'" src="assets/images/no-badge.svg" alt="" width="13" height="13"
                    class="position-absolute" style="right: -10%;top: -5%;">
                  <!-- <img [src]="item.badge" alt="" width="13" height="13" class="position-absolute" style="margin-left: 18%;"> -->
                  <img *ngIf="item.image == null" src="assets/images/no-poverty.png" alt="" width="28" height="28"
                    class="img-circle">
                  <img *ngIf="item.image != null" [src]="item?.image" alt="" width="28" height="28" class="img-circle">
                </div>
                <p class="ml-3 mb-0 mulish-normal text-xxs ">{{item.name}}</p>
              </div>

              <!-- banner info  -->
              <div id="info{{item.id}}" class="row mx-0 sdg-info info-width-badge container font-normal"
                *ngIf="item.bannerClicked">
                <div class="position-absolute info-close-button pointer-cursor "><img
                    src="assets/images/close-movie.svg" alt="" class="info-window-close"
                    (click)="closeBannerInfo(item)"></div>
                <div class="col-12 px-0 border-btm d-flex flex-row align-items-center pb-4">
                  <div class="d-flex align-items-center pr-4">
                    <img *ngIf="item.image == null" src="assets/images/no-poverty.png" alt=""
                      class="sdg-icon-info-window">
                    <img *ngIf="item.image != null" [src]="item?.image" alt="" class="sdg-icon-info-window">
                  </div>

                  <p class="mulish-bold text-16 mb-0 line-height-120">{{item.name}}</p>

                </div>
                <div class="d-flex justify-content-center align-items-center my-4 font-normal">
                  <div class="text-center text-xxs text-default" *ngIf="item.info.badge == 'None'">
                    <img class="m-2 badge-img" src="assets/images/no-badge.svg" alt="">
                    <div>{{'No badge yet' | translate}}</div>
                  </div>
                  <div class="text-center text-xxs text-default" *ngIf="item.info.badge == 'Gold'">
                    <img class="m-2 badge-img" src="assets/images/gold-badge.svg" alt="">
                    <div>{{'Gold' | translate}}</div>
                  </div>
                  <div class="text-center text-xxs text-default" *ngIf="item.info.badge == 'Silver'">
                    <img class="m-2 badge-img" src="assets/images/silver-badge.svg" alt="">
                    <div>{{'Silver' | translate}}</div>
                  </div>
                  <div class="text-center text-xxs text-default" *ngIf="item.info.badge == 'Bronze'">
                    <img class="m-2 badge-img" src="assets/images/bronze-badge.svg" alt="">
                    <div>{{'Bronze' | translate}}</div>
                  </div>
                  <div class="ml-4 d-flex flex-column justify-content-between">
                    <div>
                      <div class="text-xxs mb-2 text-default">
                        {{'Total score in this SDG' | translate}}
                      </div>
                      <div class="score-chip mb-3">
                        <span class="text-xxs">
                          {{'Score :' | translate}} {{item.info.score}} / {{item.info.maximum_score}}
                        </span>
                      </div>
                    </div>
                    <div class="">
                      <div class="text-xxs mb-2 text-default">
                        {{'Questions completed :' | translate}} {{item.info.answered_questions}} /
                        {{item.info.total_questions}}
                      </div>
                      <div class="custom-progress">
                        <div class="progress">
                          <div class="progress-bar bg-primary" role="progressbar"
                            [style.width.%]="item.info.attempted_percentage" aria-valuenow="12" aria-valuemin="0"
                            aria-valuemax="100"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="text-xxs mulish-normal text-center text-default text-break"
                  *ngIf="item.info.badge != 'Gold' && item.info.answered_questions != item.info.total_questions">
                  <!-- {{'You’re 50 more points away to earn gold badge for this topic, continue playing' | translate}} -->
                  {{'You’re pointNeed more points away to earn upComingBadge badge for this topic, continue playing' | translate: {pointNeed: item.pointNeed, upComingBadge: item.upComingBadge} }}
                </div>

                <div
                  class="bg-danger py-2 px-3 flex-center badge-custom cursor-pointer mulish-bold btn-light btn-block my-3 border-light-custom text-white"
                  (click)="viewSdgQuestions(item)">
                  <div *ngIf="item.info.answered_questions < item.info.total_questions">
                    {{'Start quiz' | translate | uppercase}} </div>
                  <div *ngIf="item.info.answered_questions == item.info.total_questions">
                    {{'View' | translate | uppercase}} </div>
                  <mat-icon class="ml-3">arrow_right_alt</mat-icon>
                </div>

              </div>
              <!-- banner info  -->

            </div>
          </div>

        </div>
      </div>
      <!-- map banner loggedin -->

      <agm-map *ngIf="lstExpeditionMap.length ==0" #AgmMap [zoom]="zoom" [styles]=style [minZoom]="2"
        class="map-height " [maxZoom]="4" [streetViewControl]="false">
      </agm-map>
      <agm-map #AgmMap2 class="map-height" [ngClass]="{'logout-map-ht': !isLoggedIn}"
        *ngIf="lstExpeditionMap.length !=0" (mapReady)="expditionMapReady($event)" [latitude]="lat" [longitude]="lng"
        [zoom]="zoom" [styles]=style [minZoom]="2" [maxZoom]="4" [streetViewControl]="false">

        <agm-overlay (markerClick)="clickedMarker(country, country,iw)"
          *ngFor="let country of lstExpeditionMap; let i = index" [latitude]="country.latitude"
          [longitude]="country.longitude">
          <div class="position-relative cursor-pointer">
            <img *ngIf="country?.flag == null" src="assets/images/world.svg" height="46" width="46">
            <img *ngIf="country?.flag != null" [src]="country?.flag" height="46" width="46">
            <img *ngIf="country?.info?.badge == 'None'" src="assets/images/no-badge.svg" alt="" width="23" height="23"
              class="position-absolute" style="right: -10%;top: -5%;">
            <img *ngIf="country?.info?.badge == 'Silver'" src="assets/images/silver-badge.svg" alt="" width="23"
              height="23" class="position-absolute" style="right: -10%;top: -5%;">
            <img *ngIf="country?.info?.badge == 'Gold'" src="assets/images/gold-badge.svg" alt="" width="23" height="23"
              class="position-absolute" style="right: -10%;top: -5%;">
            <img *ngIf="country?.info?.badge == 'Bronze'" src="assets/images/bronze-badge.svg" alt="" width="23"
              height="23" class="position-absolute" style="right: -10%;top: -5%;">
          </div>
          <agm-info-window #iw [isOpen]="isInfoWindowOpen(country.id)" (showCloseButton)="false">
            <div class="row mx-0 info-width">
              <div class="position-absolute info-close-button pointer-cursor "><img src="assets/images/close-movie.svg"
                  alt="" class="info-window-close" (click)="closeInfoWindow2(lstExpeditionMap)"></div>
              <div class="col-12 px-0 border-btm d-flex flex-row align-items-center pb-4">
                <div class="d-flex align-items-center pr-4"><img [src]="country?.flag" alt=""
                    class="sdg-icon-info-window"></div>

                <p class="mulish-bold text-16 mb-0 line-height-120">{{country.name}}</p>

              </div>


              <div class="d-flex justify-content-center align-items-center my-4 font-wt-400 font-normal">
                <div class="text-center text-xxs text-default" *ngIf="country.info.badge == 'None'">
                  <img class="m-2 badge-img" src="assets/images/no-badge.svg" alt="">
                  <div>{{'No badge yet' | translate}}</div>
                </div>
                <div class="text-center text-xxs text-default" *ngIf="country.info.badge == 'Gold'">
                  <img class="m-2 badge-img" src="assets/images/gold-badge.svg" alt="">
                  <div>{{'Gold' | translate}}</div>
                </div>
                <div class="text-center text-xxs text-default" *ngIf="country.info.badge == 'Silver'">
                  <img class="m-2 badge-img" src="assets/images/silver-badge.svg" alt="">
                  <div>{{'Silver' | translate}}</div>
                </div>
                <div class="text-center text-xxs text-default" *ngIf="country.info.badge == 'Bronze'">
                  <img class="m-2 badge-img" src="assets/images/bronze-badge.svg" alt="">
                  <div>{{'Bronze' | translate}}</div>
                </div>
                <div class="ml-4 d-flex flex-column justify-content-between">
                  <div>
                    <div class="text-xxs mb-2 text-default">
                      {{'Total score in this country' | translate}}
                    </div>
                    <div class="score-chip mb-3 font-bold">
                      {{'Score :' | translate}} {{country.info.score}} / {{country.info.maximum_score}}
                    </div>
                  </div>
                  <div class="">
                    <div class="text-xxs text-default mb-2">
                      {{'Questions completed :' | translate}} {{country.info.answered_questions}} /
                      {{country.info.total_questions}}
                    </div>
                    <div class="custom-progress">
                      <div class="progress">
                        <div class="progress-bar bg-primary" role="progressbar"
                          [style.width.%]="country?.info.attempted_percentage" aria-valuenow="50" aria-valuemin="0"
                          aria-valuemax="100"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="text-xxs text-center text-default font-wt-400 mulish-normal text-break"
                *ngIf="country.info.badge != 'Gold' && country.info.answered_questions != country.info.total_questions">
                <!-- {{'You’re 50 more points away to earn gold badge for this topic, continue playing' | translate}} -->
                <!-- You’re {{country?.pointNeed}} more points away to earn {{country?.upComingBadge}} badge for this topic,
                continue playing -->
                {{'You’re pointNeed more points away to earn upComingBadge badge for this topic, continue playing' | translate: {pointNeed: country?.pointNeed, upComingBadge: country?.upComingBadge} }}
              </div>

              <div
                class="bg-danger py-2 px-3 flex-center badge-custom cursor-pointer mulish-bold btn-light btn-block my-3 border-light-custom text-white"
                (click)="expeditionMarkerCliked(country);closeInfoWindow2(lstExpeditionMap)">
                <div class="font-15px" *ngIf="country.info.answered_questions < country.info.total_questions">
                  {{'Start quiz' | translate | uppercase}} </div>
                <div class="font-15px" *ngIf="country.info.answered_questions == country.info.total_questions">
                  {{'View' | translate | uppercase}} </div>
                <mat-icon class="ml-3">arrow_right_alt</mat-icon>
              </div>

            </div>
          </agm-info-window>
        </agm-overlay>

      </agm-map>
    </div>

  </div>
</div>
